import {CommandBase} from './command-base';

export class SubscribeUsersCommand extends CommandBase {
  constructor() {
    super('SubscribeUsersCommand');
  }
}
